import ShopType from "@/enum/ShopType";
import ShippingAddressDTO from "../ShippingAddressDTO";

export enum SupplierType {
    DUMMY_SUPPLIER = "DUMMY_SUPPLIER",
    NORMAL = "NORMAL",
}

/**
 * 分销代发合作关系Dto
 */
export default interface PartnershipDTO {
    /**
     * 代理商视角：代理商对供货商设置的排序值/序号；
     * 供货商视角：供货商对代理商设置的排序值/序号
     */
    index?: number;

    /**
     * 代理商视角：代理商对供货商设置的昵称/别名；
     * 供货商视角：供货商对代理商设置的昵称/别名
     */
    alias?: string;

    /**
     * 供货商ID
     * 代理商视角：供货商ID（即供货商店铺所在Company的ID）；
     * 供货商视角：无作用
     */
    supplerId?: number;

    /**
     * 建立合作关系时间
     */
    dateCooperated: string;
    /**
     * 代理商视角：供货商名称；
     * 供货商视角：代理商店铺名称
     */
    name: string;
    /**
     * 合作关系ID(开启合作之后才有)
     */
    partnershipId?: number;

    /**
     * 前端值
     * 建立合作关系后（合作中或者已取消合作），合作关系对应的代理商店铺Id
     */
    _retailerShopId?: number;

    /**
     * 代理商视角：供货商店铺ID；
     * 供货商视角：代理商店铺ID
     */
    shopId?: number;
    /**
     * 代理商视角：供货商店铺类型；
     * 供货商视角：代理商店铺类型
     */
    shopType?: ShopType;
    /**
     * 是否停止合作
     */
    suspended?: boolean;
    /**
     * 取消合作时间
     */
    suspendedTime?: string;
    /**
     * 代理商视角：供应商类型；
     * 供货商视角：无作用
     */
    type?: SupplierType;

    // 代理商视角：代理商为该分销关系绑定的发货地址。
    // 供货商视角：代理商为该分销关系绑定的发货地址。
    shippingAddress?: ShippingAddressDTO;
}
